import { render, staticRenderFns } from "./SecurityPolicy.vue?vue&type=template&id=19aeb8b3&"
import script from "./SecurityPolicy.vue?vue&type=script&lang=js&"
export * from "./SecurityPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports